import { cn } from "./classNames-BzrkDnOD.js";
import { jsx } from "react/jsx-runtime";
import { CollapsibleTrigger, Content, Root } from "@radix-ui/react-collapsible";
//#region src/components/Collapsible/CollapsibleContent.tsx
const CollapsibleContent = ({ ref, className, children, ...props }) => /* @__PURE__ */ jsx(Content, {
	ref,
	className: cn("tw:data-[state=closed]:animate-collapsible-close", "tw:data-[state=open]:animate-collapsible-open", className),
	...props,
	children
});
//#endregion
//#region src/components/Collapsible/CollapsibleTrigger.tsx
/**
* A `Collapsible` toggle.
*
* - Carries `tailwindcss-preflight`: the trigger renders a bare `<button>` and the package's
*   reset is opt-in, so without it a host app without a global reset gets UA button chrome.
* - Under `asChild` the class lands on a design component that already declares it — harmless.
*/
const CollapsibleTrigger$1 = ({ ref, className, children, ...props }) => /* @__PURE__ */ jsx(CollapsibleTrigger, {
	ref,
	className: cn("tailwindcss-preflight", className),
	...props,
	children
});
//#endregion
//#region src/components/Collapsible/Collapsible.tsx
const Collapsible = (props) => /* @__PURE__ */ jsx(Root, { ...props });
Collapsible.Trigger = CollapsibleTrigger$1;
Collapsible.Content = CollapsibleContent;
//#endregion
export { Collapsible };

//# sourceMappingURL=Collapsible-BQXWEOBC.js.map